import { render, staticRenderFns } from "./quote-ref.vue?vue&type=template&id=5fe3d86f&scoped=true&lang=pug&"
import script from "./quote-ref.vue?vue&type=script&lang=js&"
export * from "./quote-ref.vue?vue&type=script&lang=js&"
import style0 from "./quote-ref.vue?vue&type=style&index=0&id=5fe3d86f&prod&lang=scss&scoped=true&"
import style1 from "./quote-ref.vue?vue&type=style&index=1&id=5fe3d86f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fe3d86f",
  null
  
)

/* custom blocks */
import block0 from "./quote-ref.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports